import { COLOR_GREEN, COLOR_RED, ICON_GREEN, ICON_RED, TableElementFormatter } from '../../shared/model/table-element-formatter';
import { current } from '../component/device/device-selector/device-selector.component';
import { DsDevice } from '../model/ds-device';

export class DsDeviceFormatter implements TableElementFormatter<DsDevice> {
  private fieldName: string;

  constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  createElementCssClasses = (data: DsDevice): string => {
    if (this.fieldName == current) {
      if (!data.current)
        return COLOR_RED;

      return COLOR_GREEN;
    }
    if (!data[this.fieldName])
      return ICON_RED;

    return ICON_GREEN;
  };
}
